module.exports = __webpack_public_path__ + "img/pbs-logo.3b89e5a7.jpg";